import { gql } from '@/setup/api';

export const getLocations = async ({ commit }) => {
  const query = `
    query {
      currentOrganization {
        id
        locations {
          title
          id
          stations {
            title
            id
          }
        }
      }
    }
  `;

  const data = await gql.request(query);
  if (data) commit('setLocations', data.currentOrganization.locations);
  return data;
};
